import { ProductType } from '@/AppGlobal';
import { t } from 'i18next';
import { useMemo } from 'react';
import { ReactComponent as DefaultIcon } from '../BankCardTag/images/default_icon.svg';
import style from './index.module.less';

type BankCardStickerProps = {
  productType: ProductType;
};

function BankCardSticker(props: BankCardStickerProps) {
  const { productType } = props;
  const nameMap = useMemo(
    () =>
      new Map([
        [ProductType.CL, t('vhkPub.help.cl')],
        [ProductType.KKC, t('vhkPub.help.kkc')],
        [ProductType.CMC, t('vhkPub.help.cmc')],
      ]),
    []
  );
  return (
    <div className={style.layout}>
      <DefaultIcon className={style.default_icon} />
      {nameMap.get(productType)}
    </div>
  );
}

export default BankCardSticker;
